/* SIZESOFTX
=========================================================================================
* Descripción: Saldos de comunicación (canales WhatsApp/correo)
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 11/09/2026 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import React, { useEffect, useState } from "react";
import { Alert, Box, Card, CardContent, Chip, CircularProgress, Grid, Stack, Typography } from "@mui/material";
import { apiComunicaciones } from "../settings/supportApi";

const ComunicacionesPage = () => {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    apiComunicaciones()
      .then(setRows)
      .catch((err) => setError(err.message));
  }, []);

  if (error) return <Alert severity="error">{error}</Alert>;
  if (!rows)
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
        <CircularProgress />
      </Box>
    );

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Saldos de comunicación
      </Typography>
      <Grid container spacing={2}>
        {rows.map((c) => (
          <Grid item xs={12} md={6} lg={4} key={c.uId}>
            <Card>
              <CardContent>
                <Stack>
                  <Typography variant="h6">
                    {c.canal} {c.bajoSaldo && <Chip size="small" color="warning" label="Bajo saldo" />}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {c.llave} {c.descripcion ? `· ${c.descripcion}` : ""}
                  </Typography>
                  <Typography variant="body2">
                    Saldo de consumo: <b>{c.saldoConsumo}</b>
                  </Typography>
                  <Typography variant="body2">Límite de alerta: {c.limiteAlerta}</Typography>
                  <Typography variant="body2">Consumo total: {c.consumoTotal}</Typography>
                  <Typography variant="body2" color={c.activo ? "success.main" : "error"}>
                    {c.activo ? "Activo" : "Inactivo"}
                  </Typography>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ComunicacionesPage;